import { Md } from "@client/component";
import { Color } from "@client/style";
import { css } from "@emotion/css";
import { getXPercent, SaleX } from "@share";
import { Card, Tag, Tooltip as AntTooltip } from "antd";
import { Axis, Chart, Coordinate, Interval, Tooltip } from "bizcharts";
import { adjustHue, lighten } from "polished";
import React, { useEffect, useState } from "react";

export const XTagConfig = {
    [SaleX.Buy]: {
      label: "购买",
    },
    [SaleX.NoBuy]: {
      label: "未购买",
    },
    [SaleX.DepositBuy]: {
      label: "付定金并购买",
    },
    [SaleX.Deposit]: {
      label: "付定金未购买",
    },
    [SaleX.BuyNow]: {
      label: "立即购买",
    },
    [SaleX.BuyLater]: {
      label: "搜寻后返回购买",
    },
    [SaleX.BuyDeposit]: {
      label: "折扣价购买",
    },
    [SaleX.BuyFull]: {
      label: "搜寻后返回购买",
    },
    [SaleX.BuyDeposit_O]: {
      label: "折扣价从对手处购买",
    },
    [SaleX.BuyFull_O]: {
      label: "搜寻后返回对手处购买",
    },
  },
  x2color = (x) => adjustHue(50 * x - 100, lighten(0.1, Color.main));

const SaleValues = Object.values(SaleX).filter((s) => typeof s === "number") as SaleX[];

export function SaleResult({ sale_X }: { sale_X: SaleX[] }) {
  const [showCount, setShowCount] = useState(0);
  useEffect(() => {
    const interval = setInterval(
      () =>
        setShowCount((c) => {
          if (c > sale_X.length) {
            clearInterval(interval);
          }
          return c + Math.random() * 20;
        }),
      300
    );
    return () => clearInterval(interval);
  }, []);

  return (
    <Card
      title={"买家序列"}
      className={css`
        width: ${Md.fnWidth};
        margin: 5rem auto;
      `}
    >
      {sale_X.slice(0, showCount).map((x, i) => (
        <AntTooltip title={XTagConfig[x].label}>
          <Tag
            className={css`
              margin: 0.2rem;
              width: 1.2rem;
              height: 1.2rem;
              padding: 0;
            `}
            color={x2color(x)}
          />
        </AntTooltip>
      ))}{" "}
      {showCount >= sale_X.length && (
        <Chart
          height={200}
          data={SaleValues.map((x: SaleX) => ({
            item: XTagConfig[x].label,
            color: x2color(x),
            percent: getXPercent(sale_X, x),
          })).filter((s) => s.percent)}
          scale={{
            percent: {
              formatter: (val) => ~~(val * 100) + "%",
            },
          }}
          autoFit
        >
          <Coordinate type="theta" radius={0.75} />
          <Tooltip showTitle={false} />
          <Axis visible={false} />
          <Interval
            position="percent"
            adjust="stack"
            color="item"
            style={{
              lineWidth: 1,
              stroke: "#fff",
            }}
            label={[
              "*",
              {
                content: (data) => {
                  return `${data.item}: ${(data.percent * 100).toFixed(0)}%`;
                },
              },
            ]}
          />
        </Chart>
      )}
    </Card>
  );
}
